import { css } from '@emotion/react';
import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';
import { MentoringProgramGuideRequirementType, MentoringProgramMilestone } from 'redux/schemas/models/mentoring-program-guides';
import { CellProps } from '.';


const AppearsInCell = ({
  className,
  cell,
}: CellProps) => {
  const translationBase = t.MENTORING_PROGRAMS.GUIDANCE.GUIDES;

  const styles = css`
    .icon {
      padding: 4px;
    }
  `;

  const requirement = cell.getValue();

  let iconName = 'goal';
  let title = translationBase.APPEARS_IN.MY_GOALS();
  if (requirement.type === MentoringProgramGuideRequirementType.CONNECTION_SESSION) {
    iconName = 'calendar';
    title = translationBase.APPEARS_IN.SINGLE_SESSION(requirement.criteria.upperLimit);
  }
  if (requirement.type === MentoringProgramGuideRequirementType.SESSION) {
    iconName = 'calendar';
    if (requirement.criteria.sequence?.length === 1) {
      title = translationBase.APPEARS_IN.SINGLE_SESSION(
        requirement.criteria.sequence?.[0],
      );
    } else {
      title = translationBase.APPEARS_IN.MULTI_SESSION(
        requirement.criteria.sequence?.[0],
        requirement.criteria.sequence?.[requirement.criteria.sequence?.length - 1],
      );
    }
  }
  if (requirement.type === MentoringProgramGuideRequirementType.MILESTONE) {
    iconName = 'enrollment';
    title = translationBase.APPEARS_IN.PROFILE_COMPLETION();
  }

  return (
    <div css={styles} className={`d-flex align-items-center ${className}`}>
      <NvIcon
        icon={iconName}
        size='xss-smallest'
        className='rounded-circle color-gray-2 bg-color-gray-7 mr-1'
      />
      <div className='semi-bold'>{title}</div>
    </div>
  );
};

export default AppearsInCell;
